<template>

    <q-dialog v-model="showModal" full-width>
        <q-card style="width: 900px!important" class="bg-black">
            <q-card-section class="row justify-between items-center q-py-sm q-pr-sm text-white">
                {{ title }}
                <q-space />
                <q-btn icon="mdi-close" flat round dense v-close-popup />
            </q-card-section>
            <q-card-section class="q-pa-sm">
                <video controls autoplay class="full-width" :src="cacheBustedSrc" />
            </q-card-section>
        </q-card>

    </q-dialog>

</template>
<script>

    export default {
        name: 'dialog-video-player',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            title: String,
            src: String,
        },
        data() {
            return {

            }
        },

        computed: {
            showModal: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$emit('update:show', value)
                }
            },
            cacheBustedSrc() {
                return `${this.src}?cb=${Date.now()}`
            },
        }

    }
</script>
